import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var KeysPipe = (function () {
    function KeysPipe() {
    }
    KeysPipe.prototype.transform = function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj);
    };
    return KeysPipe;
}());
export { KeysPipe };
KeysPipe.decorators = [
    { type: Pipe, args: [{ name: 'keys' },] },
];
/** @nocollapse */
KeysPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=keys.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/keys.js
// module id = 250
// module chunks = 4